import { Injectable } from '@angular/core';
import { GeralGoApi, SimuladorGoApi } from '@gestor-web/@core/api/go';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LancamentosRejeitadosOutrasDespesasService {
  constructor(private geralGoApi: GeralGoApi, private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtroMotivoArquivo?: string,
    filtroCriticaGuia?: string,
  ) {
    return this.simuladorGoApi
      .fetchLancamentosRejeitadosOutrasDespesas({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        filtro_motivo_arquivo: filtroMotivoArquivo,
        filtro_critica_guia: filtroCriticaGuia,
      })
      .pipe(
        map(data => ({
          items: data.items ?? [],
        })),
        catchError(() => of({ items: [] })),
      );
  }

  getFiltro() {
    return this.geralGoApi.fetchLancamentosRejeitadosOutrasDespesasFiltro().pipe(
      map(data => data.items ?? []),
      catchError(() => of([])),
    );
  }
}
